// This file is auto-generated by @hey-api/openapi-ts

import { bambiApi } from "../internal/api.ts";

import {
  type WhatTimeIsItRetrieveApiArg,
  type WhatTimeIsItRetrieveApiResponse,
} from "./operations.gen.ts";

export const addTagTypes = ["what-time-is-it"] as const;

const injectedWhatTimeIsItRtkApi = bambiApi.enhanceEndpoints({ addTagTypes }).injectEndpoints({
  endpoints: (build) => ({
    whatTimeIsItRetrieve: build.query<WhatTimeIsItRetrieveApiResponse, WhatTimeIsItRetrieveApiArg>({
      query: () => ({ url: `/what-time-is-it/` }),
      providesTags: ["what-time-is-it"],
    }),
  }),
  overrideExisting: false,
});

export const { useWhatTimeIsItRetrieveQuery, useLazyWhatTimeIsItRetrieveQuery } =
  injectedWhatTimeIsItRtkApi;
